interface Colors {
  infoName: string;
  infoLabel: string;
  infoAddress: string;
  blue: string;
  lightBlue: string;
}

export const colors: Colors = {
  infoName: "#4b4a4a",
  infoLabel: "#888888",
  infoAddress: "#6f7073",
  blue: "#0DA3D8",
  lightBlue: "#56CCF2"
};
